import { Avatar, Box } from "native-base";
import { Pressable } from "react-native";
import { Svg } from "react-native-svg";

const CommonAvatar = ({
  width,
  size = "xs",
  height,
  bgcolor,
  svg,
  svgwh = "19",
  view = "0 0 19 19",
  onPress = () => {},
  touchable = false,
  justifyContent = "center",
  pt = "",
}) => {
  const avatar = () => {
    return (
      <Box justifyContent={justifyContent} alignItems="center" pt={pt}>
        <Avatar size={size} width={width} height={height} bg={bgcolor}>
          <Svg width={svgwh} height={svgwh} viewBox={view}>
            {svg}
          </Svg>
        </Avatar>
      </Box>
    );
  };
  return touchable ? (
    <Pressable onPress={onPress}>{avatar()}</Pressable>
  ) : (
    avatar()
  );
};

export default CommonAvatar;
